<script lang="ts">
    import type Monster from "../../lib/monster";
    import MonsterPicture from '../Picture/index.svelte';
    import MonsterAttributes from '../Attributes/index.svelte';

    export let name: string;
    export let monster: Monster;
</script>

<article class={'monster-properties'}>
    <section class='picture'>
        <MonsterPicture monster={monster}/>
    </section>
    <section class='attributes'>
        <MonsterAttributes monster={monster}/>
    </section>
    <section class='details'>
        <subsection class='name-input'>
            <label for='name'>Name</label>
            <input id='name' type='text' bind:value={name}/>
        </subsection>
        {#if (monster.serialized.type === monster.serialized.subType)}
            <subsection class='type'><b>Type: </b>{monster.serialized.type} (Pure)</subsection>
        {:else}
            <subsection class='type'>
                <span><b>Type: </b>{monster.serialized.type}</span>
                <span><b>Sub-Type: </b>{monster.serialized.subType}</span>
            </subsection>
        {/if}
        <subsection class='genetics'>
            <h2>Genetics</h2>
            <div class='genetic-properties'>
                <span><b>Gender: </b>{monster.serialized.gender}</span>
                <span><b>Genetic potency: </b>{monster.serialized.geneticStrength}</span>
                <span><b>Evolvable: </b>{monster.serialized.canEvolve}</span>
            </div>
        </subsection>
        <subsection class='traits'>
            <h2>Traits</h2>
            <ul class='trait-list'>
                {#each monster.serialized.traits as { name, description }}
                    <li><b>{name}: </b>{description}</li>
                {/each}
            </ul>
        </subsection>
        <subsection class='moves'>
            <h2>Moves ({monster.serialized.numMoves} active slots)</h2>
            <ul class='move-list'>
                {#each monster.serialized.moves as { name, description }}
                    <li><b>{name}: </b>{description}</li>
                {/each}
            </ul>
        </subsection>
    </section>
</article>

<style>
.monster-properties {
    display: grid;
    height: 500px;
    width: 1000px;
    grid-template-areas: "picture details"
                         "attributes details";
    grid-template-rows: repeat(2, 250px);
    grid-template-columns: 250px 1fr;
    background-color: gainsboro;
    padding: 15px;
    margin: 0 auto;
}

section {
    overflow: hidden;
}

h2 {
    margin: 5px 0px;
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.details {
    grid-area: details;
    display: grid;
    grid-template-areas: "name type"
                         "genetics genetics"
                         "traits traits"
                         "moves moves";
    grid-template-rows: repeat(3, max-content) 1fr;
    grid-template-columns: max-content 1fr;
    grid-gap: 15px;
    padding-left: 15px;
}

.picture {
    grid-area: picture;
}

.name-input {
    grid-area: name;
}

.type {
    grid-area: type;
}

.attributes {
    grid-area: attributes;
    display: flex;
    flex-direction: column;
}

.traits {
    grid-area: traits;
    display: flex;
    flex-direction: column;
}

.trait-list > li {
    line-height: 1.5;
}

.moves {
    grid-area: moves;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.move-list {
    overflow: auto;
}

.move-list > li {
    line-height: 1.5;
}

.genetics {
    grid-area: genetics;
}

.genetic-properties {
    display: flex;
    justify-content: space-between;
}

@media only screen and (max-width: 1000px) {
    .monster-properties {
        width: 600px;
        height: 800px;
        grid-template-areas: "attributes picture"
                             "details details";
        grid-template-rows: 300px 1fr;
        grid-template-columns: repeat(2, 300px);
        padding: 15px;
    }

    .details {
        height: 500px;
        grid-template-areas: "name type"
                            "genetics genetics"
                            "traits traits"
                            "moves moves";
        grid-template-rows: repeat(3, max-content) 1fr;
        grid-template-columns: max-content 1fr;
        padding-left: 0;
    }
}

@media only screen and (max-width: 600px) {
    .monster-properties {
        width: 90vw;
        height: calc(100vh - 10vw);
        grid-template-areas: "attributes picture"
                             "details details";
        grid-template-rows: 45vw calc(100vh - 55vw);
        grid-template-columns: 45vw 45vw;
        grid-gap: 0;
        padding: 5vw;
    }

    .details {
        height: 100%;
        grid-template-areas: "name"
                             "type"
                             "genetics"
                             "traits"
                             "moves";
        grid-template-rows: repeat(5, max-content);
        grid-template-columns: 1fr;
        overflow: auto;
    }
}
</style>
